import { useWindowSize } from '@/hooks';
import { Button, Divider } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { Purchase } from '@/core/domain/purchase/Purchase.types';

interface Props {
  itemId?: number;
  calcTaxesCallback?: () => void;
  isLoadingCalcTaxes?: boolean;
  purchase?: Purchase;
}

const PurchaseItemsButtonsRepeated: React.FC<Props> = ({
  purchase,
  itemId,
  calcTaxesCallback,
  isLoadingCalcTaxes,
}) => {
  const intl = useIntl();

  const history = useHistory();
  const { isMobile } = useWindowSize();

  const purchaseReadOnly = !!purchase?.boschMigration;

  return (
    <>
      <Divider />
      <SpaceForButton>
        <Button
          block={isMobile}
          type="primary"
          onClick={() =>
            history.push(
              `/app/movements/purchases/purchasesReleases/${purchase?.id}/itemsPurchase`,
            )
          }
        >
          {intl.formatMessage({ id: 'commons.modal.button.back' })}
        </Button>

        {itemId && (
          <Button
            block={isMobile}
            type="primary"
            onClick={calcTaxesCallback}
            loading={isLoadingCalcTaxes}
            disabled={purchaseReadOnly}
          >
            {intl.formatMessage({ id: 'purchases.calculateTaxes' })}
          </Button>
        )}
      </SpaceForButton>
    </>
  );
};

export default PurchaseItemsButtonsRepeated;
